module.exports = __webpack_public_path__ + "img/stand_ruoyi_blank_cut.929c2234.png";